import React, { useState } from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./Dropdown.module.sass";
import Tooltip from "../Tooltip";
import TextInput from "../TextInput";

const Dropdown = ({
	className,
	classDropdownHead,
	classDropdownLabel,
	value,
	setValue,
	options,
	label,
	tooltip,
	small,
	upBody,
	isDisabled = false,
	dictionary,
	setSearchInput,
}) => {
	const [visible, setVisible] = useState(false);

	const handleClick = (value) => {
		setValue(value);
		setVisible(false);
	};

	return (
		<OutsideClickHandler onOutsideClick={() => setVisible(false)}>
			{label && (
				<div className={cn(styles.label, classDropdownLabel)}>
					{label}{" "}
					{tooltip && (
						<Tooltip
							className={styles.tooltip}
							title={tooltip}
							icon="info"
							place="right"
						/>
					)}
				</div>
			)}
			<div
				className={cn(
					styles.dropdown,
					className,
					{ [styles.small]: small },
					{
						[styles.active]: visible,
					}
				)}
			>
				<div
					tabIndex="0"
					className={cn(styles.head, classDropdownHead)}
					onClick={() => {
						if (!isDisabled) setVisible(!visible);
					}}
				>
					<div className={styles.selection}>
						{dictionary ? dictionary[value]?.title : value}
					</div>
				</div>
				<div className={cn(styles.body, { [styles.bodyUp]: upBody })}>
					{setSearchInput && (
						<TextInput
							placeHolder={"Search ..."}
							onChangeInput={(val) => setSearchInput(val)}
						/>
					)}
					{options.map((x, index) => (
						<div
							className={cn(styles.option, {
								[styles.selectioned]: x === value,
							})}
							onClick={() => handleClick(x, index)}
							key={"elem_" + index}
						>
							{dictionary ? dictionary[x]?.title : x}
						</div>
					))}
				</div>
			</div>
		</OutsideClickHandler>
	);
};

export default Dropdown;
